import planClickRecEngineTracking from 'core/services/planClickRecEngineTracking'
import store from 'utils/store/withMiddleware'
import { preventOnCloseEvent } from 'core/services/onClose'

function compareAppClickPlanTracking() {
  const state = store.getState()
  const { hcStorage, recEngine, plans, carriers } = state
  const redirectLink = this.dataset.link
  const planInfo = (this.dataset.planid || this.dataset.id).split('-')
  preventOnCloseEvent()

  const planId = planInfo[0]
  const policies = planInfo[2]
  const argState = {
    hcStorage,
    plans,
    policies,
    planId,
    carriers
  }

  planClickRecEngineTracking.call(this, {
    planId,
    policies,
    argState,
    storedRecEngine: { data: recEngine },
    redirectLink
  })
}

export default compareAppClickPlanTracking
